(function () {
  if (typeof Storage === "undefined") {
    console.warn("Session storage is not supported.");
    return;
  }

  // Prevent showing modal repeatedly in the same session
  if (sessionStorage.getItem("redirectModalDismissed")) {
    return;
  }

  // Detect spiders, crawlers, bots
  const userAgent = navigator.userAgent.toLowerCase();
  const isBot =
    /(bot|crawl|slurp|spider|mediapartners|facebookexternalhit|pinterest|crawler|bingpreview|ahrefs|yandex|baiduspider)/.test(
      userAgent,
    );

  if (isBot) {
    return;
  }

  if (typeof geoip2 === "undefined") {
    console.error("GeoIP2 is not available.");
    return;
  }

  geoip2.country(
    function (location) {
      const country = location.country.iso_code;

      if (country !== "CA") return;

      const modal = document.getElementById("redirect-modal");
      if (!modal) return;

      const counterEl = modal.querySelector("#redirect-counter");

      const stayBtn = document.getElementById("redirect-confirm");
      const continueBtn = document.getElementById("redirect-cancel");

      let countdown = 20;
      let timer;

      function updateCounter() {
        counterEl.textContent = countdown;
      }

      function redirectToCA() {
        const currentUrl = window.location.href;
        const urlObj = new URL(currentUrl);
        const params = new URLSearchParams(urlObj.search);

        // Preserve UpPromote affiliate parameter if it exists
        const scaRef = params.get("sca_ref");

        let targetUrl = currentUrl.replace("fragflex.com", "fragrancebuy.ca");

        // If UpPromote affiliate parameter exists, reappend it
        if (scaRef) {
          targetUrl = `https://fragrancebuy.ca${urlObj.pathname}?sca_ref=${scaRef}`;
        }

        window.location.href = targetUrl;
      }

      function showModal() {
        modal.classList.remove("hidden");
        requestAnimationFrame(() => {
          modal.classList.add("active");
        });

        updateCounter();
        timer = setInterval(() => {
          countdown--;
          updateCounter();

          if (countdown <= 0) {
            clearInterval(timer);
            redirectToCA();
          }
        }, 1000);
      }

      function closeModal() {
        modal.classList.remove("active");
        modal.addEventListener(
          "transitionend",
          () => {
            modal.classList.add("hidden");
          },
          { once: true },
        );
      }

      stayBtn.addEventListener("click", () => {
        clearInterval(timer);
        closeModal();
        sessionStorage.setItem("redirectModalDismissed", "true");
      });

      continueBtn.addEventListener("click", () => {
        clearInterval(timer);
        redirectToCA();
      });

      showModal();
    },
    function (error) {
      console.error("GeoIP error:", error);
    },
  );
})();
